export { default as ImageLoader } from './image-loader';
export { default as ImageWriter } from './image-writer';
export { getBinaryImageMetadata } from './lib/category-api/binary-image-api';
export { isImageTypeSupported, getDefaultImageType } from './lib/category-api/image-type';
export { isImage, getImageType, getImageSize, getImageData } from './lib/category-api/parsed-image-api';
export { loadImage } from './lib/texture-api/load-image';
export { loadImageArray } from './lib/texture-api/load-image-array';
export { loadImageCube } from './lib/texture-api/load-image-cube';
export { default as HTMLImageLoader } from './image-loader';
import { getDefaultImageType } from './lib/category-api/image-type';
export function getSupportedImageType() {
  var imageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return getDefaultImageType();
}
export { isBinaryImage, getBinaryImageMIMEType, getBinaryImageSize } from './lib/deprecated/binary-image-api-deprecated';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/images/dist/esm/index.js